// ANCHOR React Icons
import { Icon } from 'react-icons-kit';
import { ellipsisV } from 'react-icons-kit/fa/ellipsisV';

// ANCHOR Base
import {
  Button, KIND, SIZE, SHAPE,
} from 'baseui/button';
import { PLACEMENT, StatefulPopover } from 'baseui/popover';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonUpdateFormOutlineTabListItemMenu } from '../LyonUpdateFormOutlineTabListItemMenu';

// ANCHOR Styles
import { BUTTON } from './styles';

const ELLIPSIS_ICON = <Icon icon={ellipsisV} />;
const CONTENT = <LyonUpdateFormOutlineTabListItemMenu />;

export const LyonUpdateFormOutlineTabListItemButton = constant(() => (
  <StatefulPopover
    content={CONTENT}
    placement={PLACEMENT.auto}
    accessibilityType="tooltip"
    returnFocus
    autoFocus
    renderAll
  >
    <Button
      type="button"
      kind={KIND.tertiary}
      size={SIZE.compact}
      shape={SHAPE.square}
      overrides={BUTTON}
    >
      {ELLIPSIS_ICON}
    </Button>
  </StatefulPopover>
));
